import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
// Existing
import DegreeHomeV2BranchWrapper from 'bundles/degree-home/components/DegreeHomeV2BranchWrapper';
import DegreeSummary from 'bundles/degree-home/components/DegreeSummary';
// Degree Home v2
import DegreeHomeAppV2AndV3Container from 'bundles/degree-home/components/v2/DegreeHomeAppV2Container';
import DegreeHomeV2 from 'bundles/degree-home/components/v2/DegreeHomeV2';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';
import DegreePlanPropertiesContextProvider from 'bundles/degree-home/components/v3-dpm/context/DegreePlanPropertiesContext';
// Degree Home v3
import Academics from 'bundles/degree-home/components/v3-dpm/pages/Academics';
import InProgress from 'bundles/degree-home/components/v3-dpm/pages/InProgress';
import constants from 'bundles/premium-certificate/constants/constants';

import { useRedirectIfV3 } from './components/v3-dpm/lib/experiments';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const DegreeApp = (props: $TSFixMe) => (
  <DegreePlanPropertiesContextProvider>
    <DegreeHomeV2BranchWrapper
      v2={<DegreeHomeAppV2AndV3Container {...props} />}
      v3={<DegreeHomeAppV2AndV3Container {...props} />}
    />
  </DegreePlanPropertiesContextProvider>
);
const DegreeHome = (props: $TSFixMe) => {
  useRedirectIfV3(PATHS.IN_PROGRESS);

  return <DegreeHomeV2BranchWrapper v2={<DegreeHomeV2 {...props} />} v3={null} />;
};

export default (
  <Route path={`/${constants.degreeUrlRoot}/:degreeSlug`} component={DegreeApp}>
    <Route path={PATHS.HOME} component={DegreeHome} />
    <Route path={PATHS.SUMMARY} component={DegreeSummary} />
    <Route path={PATHS.IN_PROGRESS} component={InProgress} />
    <Route path={PATHS.ACADEMICS} component={Academics} />
    <Route path="*" getComponent={NotFound} />
  </Route>
);
